import HeroSlider from "@/components/HeroSlider";
import { TrustStrip, Marquee } from "@/components/Strips";
import { Comparison, Framework } from "@/components/Science";
import PtsBlock from "@/components/PtsBlock";
import LocationSwitcher from "@/components/LocationSwitcher";
import { StoriesPreview, Faq } from "@/components/Stories";
import { CtaBand } from "@/components/Blocks";

export default function Home() {
  return (
    <main data-testid="home-page">
      <HeroSlider />
      <TrustStrip />
      <Comparison />
      <Framework />
      <PtsBlock />
      <Marquee />
      <LocationSwitcher />
      <StoriesPreview />
      <Faq />
      <CtaBand />
    </main>
  );
}
